import React, { useState } from 'react';
import SnowAnimation from './components/SnowAnimation';
import TearOffCalendar from './components/TearOffCalendar';
import GeneralCalendar from './components/GeneralCalendar';
import ChristmasMusic from './components/ChristmasMusic';
import './App.css';

function App() {
  const [view, setView] = useState('tearoff');
  const [activeEvent, setActiveEvent] = useState('christmas');

  const events = {
    christmas: {
      date: new Date(new Date().getFullYear(), 11, 25),
      title: "До Різдва залишилось"
    },
    birthday: {
      date: new Date(new Date().getFullYear(), 3, 22),
      title: "До Дня Народження залишилось"
    }
  };

  return (
    <div className="App">
      <SnowAnimation />

      <div className="view-switcher-container">
        <div className="view-switcher">
          <button
            className={`switch-btn ${view === 'tearoff' ? 'active' : ''}`}
            onClick={() => setView('tearoff')}
          >
            Відривний
          </button>
          <button
            className={`switch-btn ${view === 'general' ? 'active' : ''}`}
            onClick={() => setView('general')}
          >
            Загальний
          </button>
        </div>
      </div>

      <div className="content-container">
        {view === 'tearoff' ? (
          <TearOffCalendar
            targetDate={events[activeEvent].date}
            title={events[activeEvent].title}
            activeEvent={activeEvent}
            onEventSelect={setActiveEvent}
          />
        ) : (
          <GeneralCalendar />
        )}
      </div>

      <ChristmasMusic />
    </div>
  );
}

export default App;
